// We use this two keys to identify the timezone options in the TimezoneSelection component,
// because we need to add the browser timezone and the default timezone as options together with the other timezone values.
// For example, we could have Browser (America/New_York) and America/New_York in the dropdown. The key helps us to distinguish them.
export const defaultTimezoneKey = 'defaultTimezone';
export const browserTimeZoneKey = 'browserTimeZone';

export const dateTimeInputFormat = 'yyyy-MM-dd HH:mm:ss';

export type Time = {
  hour: number;
  minute: number;
  second?: number;
};

export interface TimezoneSelectionOption {
  label: string;
  key: string;
  timezone: string;
  offset?: string;
}

export const UTC_ZONE = 'UTC';
